import { getDataFromSSR } from "@/handlers/client/commonClient";
import { logger } from "@/utils/logging/log-util";
import dynamic from "next/dynamic";

import {
  apstagBidCallback,
  createApsSlotsRosDesktop,
  createApsSlotsRosMobile,
  requestBiddingFromPWT,
} from "@/utils/ads";

import { useRouter } from "next/router";
import { useEffect, useState } from "react";
const AdSlot300x250 = dynamic(() => import("@/component/Ads/AdSlot300x250"));
const AdSlot728x90 = dynamic(() => import("@/component/Ads/AdSlot728x90"));
const MGIDAAdsScript = dynamic(() => import("@/component/Ads/MGIDAdsScript"));
import { parseMatchDetails } from "@/utils/ipl";
const SeriesOverview = dynamic(() =>
  import("@/component/TestSeries/SeriesOverview")
);
const SeriesList = dynamic(() => import("@/component/TestSeries/SeriesList"));
const SeriesStats = dynamic(() => import("@/component/TestSeries/SeriesStats"));

const SeriesCommonFooter = dynamic(() =>
  import("@/component/TestSeries/SeriesCommonFooter")
);

const HeadTag = dynamic(() => import("@/component/SeoTags/HeadTag"));
const GTMScript = dynamic(() => import("@/component/Ads/GTMScript"));
const Breadcrumb = dynamic(() => import("@/component/Breadcrumb"));
const BreadcrumbSchema = dynamic(() =>
  import("@/component/SeoTags/BreadcrumbSchema")
);
const ItemsList = dynamic(() => import("@/component/SeoTags/ItemsList"));
const WebpageSchema = dynamic(() =>
  import("@/component/SeoTags/WebpageSchema")
);

const SeriesPage = ({
  categoryNewsListData = null,
  isMobileDevice = false,
  matchData = null,
  faqData = null,
  currentTab = 1,
  statsData = null,
}) => {
  const router = useRouter();
  const currentPath = router?.asPath;

  const [latestMatchData, setLatestMatchData] = useState(matchData);

  useEffect(() => {
    async function getLiveMatchData() {
      try {
        const timestamp = Date.now();
        const matchResponse = await getDataFromSSR(
          `/api/getLiveMatchDetails?matchId=${matchData?.id}&time=${timestamp}`
        );
        if (matchResponse && matchResponse?.data?.data) {
          const liveMatchData = parseMatchDetails(matchResponse?.data?.data);
          setLatestMatchData(liveMatchData);
        }
        if (currentTab == 3) {
          const commResponse = await getDataFromSSR(
            `/api/getLiveCommentary?matchid=${matchData?.id}&time=${timestamp}`
          );
          if (commResponse) {
            const commData = parseMatchDetails(matchData?.data?.data);
            setCommentary(commData);
          }
        }
      } catch (err) {
        logger.error(err);
      }
    }

    if (matchData.status == "LIVE") {
      getLiveMatchData();
      const interval = setInterval(() => {
        getLiveMatchData();
      }, 10000);
      return () => clearInterval(interval);
    }
  }, []);

  const keyBindings = {
    Category:
      currentPath.split("/").length > 2
        ? [currentPath.split("/")[1], currentPath.split("/")[2]]
        : currentPath.split("/")[1],
    Keywords: categoryNewsListData?.seo_detail?.meta_keyword.split(","),
  };
  const [scrolled, setScrolled] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      window.googletag = window.googletag || { cmd: [] };

      if (window.screen.width < 900) {
        googletag.cmd.push(function () {
          googletag.destroySlots();
          googletag
            .defineSlot(
              "/1007232/News_tak_Mobile_ROS_ATF_300x250",
              [300, 250],
              "div-gpt-ad-1659434453897-0"
            )
            .addService(googletag.pubads());

          googletag
            .defineSlot(
              "/1007232/News_tak_Mobile_ROS_BTF_300x250",
              [300, 250],
              "div-gpt-ad-1659435474737-0"
            )
            .addService(googletag.pubads());

          googletag
            .defineSlot(
              "/1007232/News_tak_Mobile_ROS_Bottom_320x50",
              [320, 50],
              "div-gpt-ad-1659435612077-0"
            )
            .addService(googletag.pubads());

          // googletag.pubads().enableSingleRequest();
          googletag.pubads().disableInitialLoad();
          googletag.enableServices();
          requestBiddingFromPWT();
          Object.keys(keyBindings).forEach((key) => {
            googletag.pubads().setTargeting(key, keyBindings[key]);
          });
          scrolled &&
            googletag?.cmd.push(function () {
              var INTERSTITIALAd = googletag
                ?.defineOutOfPageSlot(
                  "/1007232/News_tak_Mobile_HP_Mweb_Interstitial",
                  googletag?.enums.OutOfPageFormat.INTERSTITIAL
                )
                ?.addService(googletag.pubads());
              INTERSTITIALAd && googletag?.display(INTERSTITIALAd);
            });
        });
      } else {
        googletag.cmd.push(function () {
          googletag.destroySlots();
          googletag
            .defineSlot(
              "/1007232/News_tak_Desktop_ROS_ATF_728x90",
              [728, 90],
              "div-gpt-ad-1659424515060-0"
            )
            .addService(googletag.pubads());
          googletag
            .defineSlot(
              "/1007232/News_tak_Desktop_ROS_ATF_300x250",
              [300, 250],
              "div-gpt-ad-1707804176041-1"
            )
            .addService(googletag.pubads());

          googletag
            .defineSlot(
              "/1007232/News_tak_Desktop_ROS_BTF_728x90",
              [728, 90],
              "div-gpt-ad-1659425743360-0"
            )
            .addService(googletag.pubads());

          // googletag.pubads().enableSingleRequest();
          googletag.pubads().disableInitialLoad();
          googletag.enableServices();
          requestBiddingFromPWT();
          Object.keys(keyBindings).forEach((key) => {
            googletag.pubads().setTargeting(key, keyBindings[key]);
          });
        });
      }
      if (scrolled) {
        apstag?.fetchBids(
          {
            slots:
              window.screen.width < 900
                ? createApsSlotsRosMobile({ mtf2: false, mtf3: false })
                : createApsSlotsRosDesktop({ mtf2: false, mtf3: false }),
            timeout: 2e3,
          },
          apstagBidCallback
        );
      }
    }, 10);
  }, [scrolled]);

  function getSeoTags() {
    switch (currentTab) {
      case 1:
        return {
          title:
            "India tour of England (इंग्लैंड बनाम भारत): ENG vs IND Test Series 2025 Live Scores, News & Schedules - NewsTak",
          description:
            "India Tour of England Test Series 2025: Get complete coverage of the England vs India Test Series 2025 (इंग्लैंड बनाम भारत टेस्ट मैच). Access schedules, squads, venues, live scores, results, match reports and exclusive news in Hindi only on NewsTak.",
          keywords:
            "India tour of England 2025 Test Series, ENG vs IND, India in England 2025, England vs India 2025, England vs India test match, England vs India test Series, England vs India live streaming, England vs India test match date and time, England vs India Schedule, Cricket news, Cricket latest news, इंग्लैंड बनाम भारत टेस्ट मैच मैच शेड्यूल, भारत बनाम इंग्लैंड टेस्ट मैच सीरीज",
          canonical: "/sports/cricket/india-tour-of-england-2025",
        };
      case 2:
        return {
          title:
            "IND vs ENG 2025 Test Series Stats: भारत बनाम इंग्लैंड टेस्ट सीरीज़ आंकड़े, टॉप बैट्समैन-बॉलर - NewsTak",
          description:
            "Check full India vs England Test Series 2025 stats (भारत बनाम इंग्लैंड आँकड़े) – Top run-scorers, highest wicket-takers, batting & bowling averages, team performance stats and more. Get all match-by-match numbers in Hindi only on NewsTak.",
          keywords:
            "India tour of England 2025 stats, IND vs ENG match stats, England vs India player stats, IND vs ENG top run scorers, India vs England top bowlers, IND vs ENG 2025 series numbers, cricket stats Hindi, भारत बनाम इंग्लैंड टेस्ट आंकड़े, बल्लेबाज़ी और गेंदबाज़ी रिकॉर्ड",
          canonical: "/sports/cricket/india-tour-of-england-2025/stats",
        };
      case 3:
        return {
          title:
            "IND vs ENG 2025 Test Series Schedule: भारत बनाम इंग्लैंड लाइव स्कोर, शेड्यूल और न्यूज़ - NewsTak",
          description:
            "Check full India vs England Test Series 2025 Schedule (भारत बनाम इंग्लैंड शेड्यूल) – Match dates, venues, timings, and team fixtures. Stay updated with every Test match detail on NewsTak in Hindi.",
          keywords:
            "India tour of England 2025 schedule, IND vs ENG 2025 fixtures, England vs India Test match schedule, IND vs ENG 2025 time table, India vs England venue list, cricket match schedule Hindi, भारत बनाम इंग्लैंड टेस्ट मैच डेट्स, इंग्लैंड बनाम भारत 2025 शेड्यूल",
          canonical: "/sports/cricket/india-tour-of-england-2025/schedule",
        };
      default:
        return {
          title: "",
          description: "",
          keywords: "",
          canonical: "",
        };
    }
  }
  const { title, description, keywords, canonical } = getSeoTags();
  const breadCrumbs = [
    {
      id: "1",
      title: "Sports",
      canonical_url: "/sports",
      amp_url: "",
    },
    {
      id: "2",
      title: "Cricket",
      canonical_url: "/sports/cricket",
      amp_url: "",
    },
    {
      id: "3",
      title: "India Tour Of England",
      canonical_url: "/sports/cricket/india-tour-of-england-2025",
      amp_url: "",
    },
    ...(currentTab == 2
      ? [
        {
          id: "3",
          title: "Stats",
          canonical_url: router?.asPath,
          amp_url: "",
        },
      ]
      : []),
    ...(currentTab == 3
      ? [
        {
          id: "3",
          title: "Schedule",
          canonical_url: router?.asPath,
          amp_url: "",
        },
      ]
      : []),
  ];
  let h1Text = () => {
    switch (currentTab) {
      case 1:
        return "IND vs ENG 2025 Test Series Overview";
      case 2:
        return "IND vs ENG 2025 Test Series Stats";
      case 3:
        return "IND vs ENG 2025 Test Series Schedule";
      default:
        return "";
    }
  };
  return (
    <div>
      <HeadTag
        title={title}
        description={description}
        keywords={keywords}
        canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + canonical}
        noAuthorTag={false}
        image={categoryNewsListData?.seo_detail?.og_image}
        lcpImage={`${categoryNewsListData?.content?.[0]?.image_small}?size=360:203`}
      />
      <GTMScript isElection={true} />
      {/* <IPLFAQSchema /> */}
      <WebpageSchema
        title={title}
        description={description}
        keywords={keywords}
        canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + canonical}
      />
      <BreadcrumbSchema breadcrumbList={breadCrumbs} />

      <ItemsList data={categoryNewsListData?.content} />
      <Breadcrumb breadcrumbList={breadCrumbs} />
      <MGIDAAdsScript delay={true} />
      <section className="px-4 py-2">
        <AdSlot300x250
          divId="div-gpt-ad-1659434453897-0"
          minWidth="300px"
          minHeight="250px"
        />

        <AdSlot728x90
          divId="div-gpt-ad-1659424515060-0"
          minWidth="728px"
          minHeight="90px"
        />
        {/* match banner + nav  */}
        <h1 className="my-4 font-semibold text-md md:text-lg">{h1Text()}</h1>
        <div
          className="bg-cover bg-center w-[110%] -mx-4 md:w-full md:-mx-0 h-fit md:rounded-t-lg py-2 px-2 md:px-4 text-white"
          style={{ backgroundImage: 'url("https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prodMatchBanner.png")' }}
        >
          <div className="px-2 md:px-6 py-2 mt-4 flex items-center justify-between">
            <div className="flex flex-col items-start gap-1">
              <h2 className="flex flex-col items-start  text-2xl font-extralight">
                {!isMobileDevice && (
                  <span className="hidden md:block">India tour of England</span>
                )}
                {!isMobileDevice && (
                  <span className="hidden md:block font-semibold"> 2025</span>
                )}
                {isMobileDevice && (
                  <span className="md:hidden">India tour of</span>
                )}
                {isMobileDevice && (
                  <span className="md:hidden">
                    {" "}
                    England <span className="font-semibold"> 2025</span>
                  </span>
                )}
              </h2>
              <div className="flex gap-2 text-sm mt-4 items-center">
                <span>5 Tests</span>
                <div className="bg-white rounded-full w-1 h-1"></div>
                <span>Thu, Jun 20 - Aug 04</span>
              </div>
            </div>
            <img
              src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/seriesLogo.png"
              alt="series logo"
              width={100}
              height={100}
            />
          </div>

          <div className="relative flex items-center justify-start -ml-3 md:-ml-0 gap-2 md:gap-4 text-md text-white pl-4 mt-2 -mb-2">
            <a
              className={`p-2 ${currentTab == 1 ? "border-b-4 border-primary" : ""
                }`}
              href={"/sports/cricket/india-tour-of-england-2025"}
            >
              Overview
            </a>
            <a
              className={`p-2 ${currentTab == 2 ? "border-b-4 border-primary" : ""
                }`}
              href={"/sports/cricket/india-tour-of-england-2025/stats"}
            >
              Stats
            </a>
            <a
              className={`p-2 ${currentTab == 3 ? "border-b-4 border-primary" : ""
                }`}
              href={"/sports/cricket/india-tour-of-england-2025/schedule"}
            >
              Matches
            </a>
          </div>
        </div>

        <div className="py-4 w-full">
          {currentTab == 1 && (
            <SeriesOverview matchData={matchData} statsData={statsData} />
          )}
          {currentTab == 2 && <SeriesStats statsData={statsData} />}
          {currentTab == 3 && <SeriesList matchData={matchData} />}
          {currentTab == 4 && <></>}
        </div>
        {currentTab == 1 && <SeriesCommonFooter
          categoryNewsListData={categoryNewsListData}
          faqData={faqData}
          isMobileDevice={isMobileDevice}
          showAds={false}
          scrolled={scrolled}
          customHeading={"रिलेटेड न्यूज"}
          showContent={true}
        />}
        {scrolled && (
          <AdSlot300x250
            divId={"div-gpt-ad-1659435474737-0"}
            minWidth="300px"
            minHeight="250px"
          />
        )}

        {scrolled && (
          <AdSlot728x90
            divId="div-gpt-ad-1659425743360-0"
            minWidth="720px"
            minHeight="90px"
          />
        )}
        <div data-type="_mgwidget" data-widget-id="1584885"></div>
        <script
          async
          dangerouslySetInnerHTML={{
            __html: `window.addEventListener("load", function() {
          (function(w,q){w[q]=w[q]||[];w[q].push(["_mgc.load"])})(window,"_mgq");
        });`,
          }}
        ></script>
      </section>
    </div>
  );
};

export default SeriesPage;
